export default __webpack_public_path__ + "static/media/it-con.a122780d.png";